'use strict';

// ─── CART DRAWER ─────────────────────────────────────────────────────────────

function openCart() {
  const drawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('cart-overlay');
  if (!drawer || !overlay) return;
  drawer.classList.add('active');
  overlay.classList.add('active');
  document.body.style.overflow = 'hidden';
  drawer.setAttribute('aria-hidden', 'false');
  refreshCartDrawer();
}

function closeCart() {
  const drawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('cart-overlay');
  if (!drawer || !overlay) return;
  drawer.classList.remove('active');
  overlay.classList.remove('active');
  document.body.style.overflow = '';
  drawer.setAttribute('aria-hidden', 'true');
}

// Lädt Cart-Daten per AJAX und rendert den Drawer-Inhalt neu.
// Kein Seiten-Reload nötig – Inhalt ist immer aktuell.
async function refreshCartDrawer() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    renderDrawerItems(cart);
    updateBadge(cart.item_count);
  } catch (err) {
    console.error('Cart refresh error:', err);
  }
}

function formatMoney(cents) {
  // CHF X.XX Format
  return 'CHF\u00A0' + (cents / 100).toFixed(2).replace('.', '.');
}

function renderDrawerItems(cart) {
  const container = document.getElementById('cart-items-container');
  const footer    = document.getElementById('cart-footer');
  const countEl   = document.getElementById('drawer-item-count');
  const totalEl   = document.getElementById('cart-total-display');

  if (!container) return;

  if (countEl) countEl.textContent = '(' + cart.item_count + ')';
  if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

  if (cart.item_count === 0) {
    if (footer) footer.style.display = 'none';
    container.innerHTML = [
      '<div style="text-align:center;padding:56px 0;color:var(--color-text-muted);">',
        '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" style="margin:0 auto 16px;opacity:.25;display:block;">',
          '<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>',
          '<line x1="3" y1="6" x2="21" y2="6"/>',
          '<path d="M16 10a4 4 0 0 1-8 0"/>',
        '</svg>',
        '<p style="font-family:var(--font-heading);font-weight:700;text-transform:uppercase;letter-spacing:.06em;">Warenkorb ist leer</p>',
        '<a href="/collections/all" onclick="closeCart()" class="btn btn--blue btn--sm" style="margin-top:16px;">Zum Shop</a>',
      '</div>'
    ].join('');
    return;
  }

  if (footer) footer.style.display = 'block';

  // Flash-Highlight am ersten Item, wenn ein Add-to-Cart diesen Render ausgelöst hat
  const shouldFlash = window.__dtFlashOnNextDrawerRender === true;
  window.__dtFlashOnNextDrawerRender = false;

  // Artikel rendern — line ist 1-basierter Index für /cart/change.js
  const itemsHtml = cart.items.map(function(item, index) {
    const line = index + 1; // 1-basiert, WICHTIG für removeCartItem()
    const imgHtml = item.image
      ? '<img src="' + item.image + '" alt="" width="72" height="72" style="width:72px;height:72px;object-fit:contain;background:var(--color-bg);border-radius:var(--radius-md);border:1px solid var(--color-border-light);padding:6px;flex-shrink:0;">'
      : '';
    const variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<p style="font-size:.78rem;color:var(--color-text-muted);">' + item.variant_title + '</p>'
      : '';

    return [
      '<div style="display:flex;gap:14px;padding:16px 0;border-bottom:1px solid var(--color-border-light);">',
        imgHtml,
        '<div style="flex:1;min-width:0;">',
          '<p style="font-family:var(--font-heading);font-weight:700;font-size:.9rem;text-transform:uppercase;color:var(--color-navy);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">' + item.product_title + '</p>',
          variantHtml,
          '<div style="display:flex;justify-content:space-between;align-items:center;margin-top:8px;">',
            '<span style="font-family:var(--font-heading);font-weight:700;color:var(--color-navy);">' + formatMoney(item.final_line_price) + '</span>',
            '<div style="display:flex;align-items:center;gap:8px;">',
              '<span style="font-size:.78rem;color:var(--color-text-muted);">' + item.quantity + '\u00D7</span>',
              '<button onclick="removeCartItem(' + line + ')" style="color:var(--color-text-muted);font-size:.75rem;font-family:var(--font-heading);font-weight:600;letter-spacing:.04em;text-transform:uppercase;background:none;border:none;cursor:pointer;padding:4px 0;">Entfernen</button>',
            '</div>',
          '</div>',
        '</div>',
      '</div>'
    ].join('');
  }).join('');

  container.innerHTML = itemsHtml;

  if (shouldFlash && typeof window.dtFlashFirstCartItem === 'function') {
    // Nach einem Tick (DOM-Paint abwarten), Flash auf erstem Line-Item
    window.requestAnimationFrame(function () { window.dtFlashFirstCartItem(); });
  }
}

// ─── CART ACTIONS ─────────────────────────────────────────────────────────────

async function addToCart(variantId, quantity, e) {
  if (e) e.preventDefault();
  const btn = e && e.currentTarget;
  if (btn) {
    btn.disabled = true;
    btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
  }
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    });
    if (!res.ok) throw new Error('Cart add failed: ' + res.status);
    // Badge im Header pulst sofort, Drawer öffnet kurz darauf
    if (typeof window.dtPulseCartBadge === 'function') window.dtPulseCartBadge();
    window.__dtFlashOnNextDrawerRender = true;
    setTimeout(() => openCart(), 300);
  } catch (err) {
    console.error('Add to cart error:', err);
  } finally {
    if (btn) {
      setTimeout(() => {
        btn.disabled = false;
        btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>';
      }, 1800);
    }
  }
}

// FIX: Verwendet `line` (1-basierter Index) statt `id` (Variant-ID).
// `id` mit einem Key-String löscht den gesamten Cart — war der ursprüngliche Bug.
async function removeCartItem(lineIndex) {
  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: lineIndex, quantity: 0 })
    });
    if (!res.ok) throw new Error('Remove failed: ' + res.status);
    const cart = await res.json();
    renderDrawerItems(cart);
    updateBadge(cart.item_count);
  } catch (err) {
    console.error('Remove cart item error:', err);
  }
}

async function updateBadge(count) {
  // Falls count nicht übergeben, von API holen
  if (count === undefined) {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      count = cart.item_count;
    } catch (err) { return; }
  }
  const el = document.getElementById('cart-count');
  if (el) {
    el.textContent = count;
    el.style.display = count > 0 ? 'flex' : 'none';
    el.setAttribute('aria-label', count + ' Artikel im Warenkorb');
  }
}

// Alias für Abwärtskompatibilität (falls irgendwo noch updateCartCount() aufgerufen)
function updateCartCount() { return updateBadge(); }

// ─── PRODUKT-SEITE ────────────────────────────────────────────────────────────

function switchImage(thumbEl, imgSrc) {
  const main = document.getElementById('product-main-img');
  if (main) main.src = imgSrc;
  document.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
  if (thumbEl) thumbEl.classList.add('active');
}

function changeQty(delta) {
  const input = document.getElementById('qty-input');
  if (!input) return;
  input.value = Math.max(1, (parseInt(input.value) || 1) + delta);
}

function selectVariant(btn, variantId, priceCents) {
  document.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');

  // ATC Button updaten
  const atcBtn = document.getElementById('main-atc-btn');
  if (atcBtn) atcBtn.dataset.variantId = variantId;

  // Preis aus window.__variants (zuverlässiger als onclick-Parameter)
  const vData = window.__variants && window.__variants[variantId];
  const cents = vData ? vData.price : priceCents;
  const compareCents = vData ? vData.compare_at_price : 0;

  // Hauptpreis setzen
  const priceEl = document.getElementById('pdp-price');
  if (priceEl && cents != null) {
    priceEl.textContent = 'CHF\u00a0' + (cents / 100).toFixed(2);
  }

  // Durchgestrichener Preis
  const oldEl = document.getElementById('pdp-price-old');
  const saveEl = document.getElementById('pdp-save-badge');
  if (oldEl && saveEl) {
    if (compareCents && compareCents > cents) {
      oldEl.textContent = 'CHF\u00a0' + (compareCents / 100).toFixed(2);
      oldEl.style.display = '';
      saveEl.textContent = 'CHF\u00a0' + ((compareCents - cents) / 100).toFixed(2) + ' sparen';
      saveEl.style.display = '';
    } else {
      oldEl.style.display = 'none';
      saveEl.style.display = 'none';
    }
  }

  // Per-Unit-Preis bei Mehrfachgebinden erkennen
  const noteEl = document.getElementById('pdp-per-unit');
  if (noteEl && vData) {
    const title = vData.title || '';
    // Anzahl aus Titel extrahieren (z.B. "12 x 0.946 Liter" → 12)
    const match = title.match(/^(\d+)\s*[xX×]/);
    if (match && parseInt(match[1]) > 1 && cents) {
      const qty = parseInt(match[1]);
      const perUnit = (cents / qty / 100).toFixed(2);
      noteEl.textContent = 'CHF\u00a0' + perUnit + ' pro Einheit · Versand wird im Checkout berechnet';
    } else {
      noteEl.textContent = 'Alle Preise in CHF · Versand wird im Checkout berechnet';
    }
  }

  // SKU updaten (Art.-Nr. der gewählten Variante)
  const skuEl = document.getElementById('pdp-sku');
  if (skuEl && vData) {
    if (vData.sku) {
      skuEl.textContent = 'Art.-Nr. ' + vData.sku;
      skuEl.style.display = '';
    } else {
      skuEl.style.display = 'none';
    }
  }

  // Lager-Badge updaten — gleiche 3-State-Logik wie im Liquid-Template
  const stockEl = document.querySelector('.pdp-stock');
  if (stockEl && vData) {
    let state = 'out';
    if (vData.available) {
      if (!vData.inventory_management) state = 'in';
      else if (vData.inventory_quantity > 0) state = 'in';
      else if (vData.inventory_policy === 'continue') state = 'backorder';
    }
    if (state === 'in') {
      stockEl.className = 'pdp-stock pdp-stock--in';
      stockEl.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg> Auf Lager \u2014 Lieferung in 2\u20135 Werktagen';
    } else if (state === 'backorder') {
      stockEl.className = 'pdp-stock pdp-stock--backorder';
      stockEl.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg> Nachbestellung — ca. 7–10 Werktage';
    } else {
      stockEl.className = 'pdp-stock pdp-stock--out';
      stockEl.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg> Aktuell nicht verfügbar';
    }
  }
}

function mainAddToCart() {
  const btn = document.getElementById('main-atc-btn');
  const variantId = btn && parseInt(btn.dataset.variantId);
  const qty = parseInt(document.getElementById('qty-input')?.value) || 1;
  if (!variantId) return;
  addToCart(variantId, qty, null);
  if (btn) {
    const orig = btn.innerHTML;
    btn.style.background = 'var(--color-success, #27ae60)';
    btn.innerHTML = '&#10003; Im Warenkorb';
    setTimeout(() => { btn.style.background = ''; btn.innerHTML = orig; }, 2200);
  }
}

// ─── NAVIGATION ──────────────────────────────────────────────────────────────

function toggleMobileNav() {
  const nav = document.getElementById('mobile-nav');
  const btn = document.querySelector('.nav-toggle');
  if (!nav) return;
  const isOpen = nav.classList.toggle('open');
  nav.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
  if (btn) btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
}

window.addEventListener('scroll', () => {
  const h = document.getElementById('site-header');
  if (h) h.classList.toggle('scrolled', window.scrollY > 60);
}, { passive: true });

// ─── INIT ─────────────────────────────────────────────────────────────────────

document.addEventListener('DOMContentLoaded', () => {
  updateBadge();

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeCart();
  });

  // Mobile-Nav schliessen bei Klick ausserhalb
  document.addEventListener('click', e => {
    const nav    = document.getElementById('mobile-nav');
    const toggle = document.querySelector('.nav-toggle');
    if (nav && nav.classList.contains('open') && !nav.contains(e.target) && toggle && !toggle.contains(e.target)) {
      nav.classList.remove('open');
      nav.setAttribute('aria-hidden', 'true');
    }
  });
});
